import { Fragment, Component } from 'react';
import { connect } from 'react-redux';
import { bool, shape } from 'prop-types';
import { Button } from '@fff-web/fff-ui-shared';
import env from '../../../utils/env';
import { getCampaignOpenStatus } from '../../../utils/campaignState';
import { assignedStates } from '../../../utils/boxStates';
import analytics, { events } from '../../../utils/analytics';
import NoItemsCTA from '../SharedComponents/NoItemsCTA/NoItemsCTA';
import { getCartSum, getTotalQty, showOrderSummary } from '../SharedComponents/utils/helperFuncs';
import ReactivateCTA from '../SharedComponents/ReactivateCTA/ReactivateCTA';
import Panel from '../SharedComponents/Panel/Panel';
import OrderSummary from '../SharedComponents/OrderSummary/OrderSummary';

class AddOnsView extends Component {
  static get propTypes() {
    return {
      sysdata: shape({}).isRequired,
      addonsCampaign: shape({
        userAccess: bool.isRequired,
      }),
      showGrowthReactivatePopUp: bool.isRequired,
    };
  }

  static get defaultProps() {
    return {
      addonsCampaign: null,
    };
  }

  render() {
    const { sysdata = {}, addonsCampaign, showGrowthReactivatePopUp } = this.props;
    const { boxData = {}, isMobile } = sysdata;
    const panelName = 'Add-Ons';

    return (
      <Panel
        sysdata={sysdata}
        panelItems={boxData.boxAddons}
        panelName={panelName}
        displayOrderSummary={showOrderSummary(boxData)}
        status={getCampaignOpenStatus(addonsCampaign)}
        hasBeenAssigned={
          boxData.currentBox ? assignedStates.includes(boxData.currentBox.boxStatus) : false
        }
        orderSummary={
          <OrderSummary
            title="Box Add Ons"
            total={getTotalQty(boxData.boxAddons)}
            sum={getCartSum(boxData.boxAddons)}
            footnote="Total does not reflect credit applied. Please check add-ons cart to verify any applicable credit."
          />
        }
        addMore={
          <Button
            style={{ margin: '12px 0 0' }}
            width="100%"
            onClick={() => {
              analytics.track(events.CLICKED_ELEMENT, {
                element_name: 'Add More',
                option_title: { panelName },
              });
              window.location = `${env.envURL}/add-ons`;
            }}
          >
            Add More
          </Button>
        }
        closedCTA={
          <div>
            <i className="fal fa-shopping-bag add-ons-closed-i" />
            <h3 className="ff-ns">Add-Ons are currently closed</h3>
            <p className="ff-ns fs-16 c-black-60">
              You will get an email when it&apos;s time to select Add-Ons for your next box! Any
              Add-Ons you select will display here.
            </p>
            <p className="ff-ns fs-12 c-black-60">(New Member Add-Ons won’t be displayed here)</p>
            <br />
          </div>
        }
        closedCTASharedBox={
          <div>
            <i className="fal fa-shopping-bag add-ons-closed-i" />
            <h3 className="ff-ns" style={{ maxWidth: '410px', margin: '20px auto 0' }}>
              Every season, FabFitFun subscribers get to shop products at 70% off retail prices.
              These add-ons ship for free with your FabFitFun box.
            </h3>
            <p className="ff-ns fs-16 c-black-60" />
            <p className="ff-ns fs-12 c-black-60" />
            <br />
          </div>
        }
        noItemCTA={
          <NoItemsCTA
            title="This Season's Add-Ons are Open!"
            desc="Woohoo, it's time to shop Add-Ons.."
            ctaLabel="Shop Add-Ons"
            isMobile={isMobile}
            onClick={() => {
              analytics.track(events.CLICKED_ELEMENT, {
                element_name: 'Add Ons',
                option_title: 'Add-ons - FabFitFun',
              });
              window.location = `${env.envURL}/add-ons/`;
            }}
          />
        }
        noItemCTASharedBox={
          <NoItemsCTA
            title="This Season's Add-Ons are Open!"
            desc="Join now to shop Add-Ons!"
            ctaLabel="GET THE BOX"
            isMobile={isMobile}
            onClick={() => {
              window.location = `${env.envURL}/get-the-box`;
              analytics.track('Clicked Element', {
                element_name: 'Get the Box',
                option_title: 'Add-ons',
              });
            }}
          />
        }
        reactiveCTA={
          <ReactivateCTA
            baseClass="add-ons"
            title="Oh no, looks like you can't shop Add-ons until you reactivate!"
            desc="This is where you'll see your Add-ons after you've selected them."
            ctaLabel="Reactivate Now"
            isMobile={isMobile}
            showGrowthReactivatePopUp={showGrowthReactivatePopUp}
          />
        }
        reactivateCTASharedBoxNoItem={
          <Fragment>
            <ReactivateCTA
              baseClass="customize"
              title="Sorry, you have to be an active member to gain access to add-ons!"
              desc=""
              ctaLabel="Reactivate Now"
              isMobile={isMobile}
              showGrowthReactivatePopUp={showGrowthReactivatePopUp}
            />
          </Fragment>
        }
        reactivateCTASharedBoxWithItems={
          <ReactivateCTA
            baseClass="customize"
            title="Sorry, you have to be an active member to gain access to add-ons!"
            desc=""
            ctaLabel="Reactivate Now"
            isMobile={isMobile}
            showGrowthReactivatePopUp={showGrowthReactivatePopUp}
          />
        }
      />
    );
  }
}

/**
 * Map state to props
 * @param {object} state - Redux state
 * @returns {object} - Props
 */
function mapStateToProps(state) {
  return {
    addonsCampaign: state.campaigns.season,
  };
}

export default connect(mapStateToProps)(AddOnsView);
